/**
 * Products Tab (Placeholder)
 *
 * Placeholder component for products/services related to a record
 */

import React from 'react';
import { Package, Plus } from 'lucide-react';

export const ProductsTab: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          Related Products & Services
        </h3>
        <button className="flex items-center gap-2 px-3 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Plus className="w-4 h-4" />
          Add Product
        </button>
      </div>

      <div className="bg-white dark:bg-[#1e293b] rounded-lg border border-gray-200 dark:border-gray-700 p-12">
        <div className="text-center">
          <Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            No products yet
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Products and services related to this record will appear here.
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-500">
            Coming soon
          </p>
        </div>
      </div>
    </div>
  );
};
